// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"dd498c5c","787":"33e1ff5f"}[chunkId] + ".chunk.js";
};